<template>
  <a class="footer-item" :href="url" target="_blank">
    <div class="footer-item-img-title">
      <div class="footer-item-img">
        <img :src="imgUrl">
      </div>
      <div class="footer-item-title">{{title}}</div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    imgUrl: String,
    title: String,
    url: String
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../assets/css/variables.scss";
  @import "../../node_modules/bootstrap/scss/bootstrap-grid";

  .footer-item {
    display: inline-block;
    padding-bottom: 40px;
    text-align: center;
    color: $color-white;
    .footer-item-img, .footer-item-title {
      display: inline-block;
    }
    .footer-item-img {
      padding-bottom: 10px;
    }
    > .footer-item-img-title {
      display: flex;
      padding: 0 12px;
      flex-direction: column;
    }
    /*&:first-of-type {*/
      /*> div {*/
        /*padding-left: 0;*/
      /*}*/
    /*}*/
    /*&:last-of-type {*/
      /*> div {*/
        /*padding-right: 0;*/
      /*}*/
    /*}*/

    /**@media (max-width: $grid-breakpoints('sm')) {*/
    @media (max-width: $breakpoint-sm) {
      width: 135px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FooterItem.vue